import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Badge, Button } from '@folio/stripes/components';
import useAuthorityWorkspaceCounts from '../hooks/useAuthorityWorkspaceCounts';
import css from './AuthorityWorkspaceNavigation.css';
var AUTHORITIES_PATH = '/czna-authorities/authorities';
var WORKSPACES = [
    { path: AUTHORITIES_PATH, labelId: 'ui-czna-authorities.authorities.workspace.records' },
    { path: "".concat(AUTHORITIES_PATH, "/my-drafts"), labelId: 'ui-czna-authorities.authorities.workspace.myDrafts' },
    { path: "".concat(AUTHORITIES_PATH, "/archive"), labelId: 'ui-czna-authorities.authorities.workspace.archive' },
];
/**
 * CZNA-973: switches between the places where a cataloguer works with
 * authorities (CZNA-1446 moved "Čeká na mě" out, into the Inbox). All three read through
 * mod-czna-authorities against Postgres — published records live in the `record` table,
 * drafts/archived items
 * in `proposal` — neither list here ever touches Solr; there was no Solr split
 * to begin with (CZNA-974 found this comment claiming one and corrected it).
 * CZNA-974: the "Records" workspace's own search additionally unions in
 * non-terminal proposals into the same list, so it is no longer record-only —
 * "published records come from Solr" was already wrong before that change.
 */
var AuthorityWorkspaceNavigation = function () {
    var _a, _b;
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var counts = useAuthorityWorkspaceCounts();
    // Check the named workspaces before treating a single trailing segment as a
    // published-record id (`my-drafts` is itself one such segment).
    var activePath = (_b = (_a = WORKSPACES.slice(1).find(function (_a) {
        var path = _a.path;
        return (pathname === path || pathname.startsWith("".concat(path, "/")));
    })) === null || _a === void 0 ? void 0 : _a.path) !== null && _b !== void 0 ? _b : AUTHORITIES_PATH;
    return (React.createElement("nav", { "data-test-authority-workspaces": true, "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.authorities.title' }), style: { display: 'flex', flexDirection: 'column', gap: '4px' } }, WORKSPACES.map(function (_a) {
        var path = _a.path, labelId = _a.labelId;
        var count = path.endsWith('/my-drafts') ? counts.myDrafts : null;
        return (React.createElement(Button, { key: path, buttonStyle: activePath === path ? 'primary' : 'default', marginBottom0: true, fullWidth: true, buttonClass: css.workspaceButton, onClick: function () { return history.push(path); }, "aria-current": activePath === path ? 'page' : undefined, style: { justifyContent: 'flex-start' } },
            React.createElement("span", { className: css.workspaceButtonContent },
                React.createElement("span", null, intl.formatMessage({ id: labelId })),
                count !== null && (React.createElement("span", { className: css.workspaceCount },
                    React.createElement(Badge, { color: "default", size: "small" },
                        React.createElement("span", { "data-testid": "my-drafts-count" }, count)))))));
    })));
};
export default AuthorityWorkspaceNavigation;
